module.exports = __webpack_public_path__ + "bfcdf09436405da47a92c155658ba8f6.png";